import React from "react";
import { Input, Label, FormGroup } from "reactstrap";

const CustomInputSearch = (props) => {
  const { name, onChange, type, placeholder, value, label, ...rest } = props;
  return (
    <div className="custom_input_field">
      <FormGroup>
        {label && (
          <Label
            className="d-block w-100 text-left mb-0 text-capitalize"
            htmlFor={name}
          >
            {label}
          </Label>
        )}
        <Input
          id={name}
          name={name}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          value={value}
          {...rest}
        />
      </FormGroup>
    </div>
  );
};

export default CustomInputSearch;
